import { GetTranscribeVideoMeta, GetTranscribeVideoPayload } from 'types/store/GetTranscribeVideo';
import { createAsyncReducer } from 'utils/Redux';

import { getTranscribeVideoActions } from '../actions';

export default createAsyncReducer<GetTranscribeVideoMeta, GetTranscribeVideoPayload>(getTranscribeVideoActions);
